import React from "react";

import { arreglar, claseEstado, formatear, vacio } from "./ConsultReportHelpers";

const ConsultReportHeader = ({ registro: r, config }) => {

    const renderValue = ({ field, type, text }) => {
        if (text !== undefined) return text;

        const value = r[field];

        return vacio(value) ? "" : formatear(value, type);
    };

    const estadoClass = (group) => {
        if (!group.status) return "";

        return claseEstado(arreglar(r[group.field]));
    };

    return (
        <div className="cabecera">

            <div>
                <div className="id">
                    {config.titlePrefix} {r[config.id]}
                </div>

                <div className="sub">
                    {config.sub.map((item, index) => (
                        <React.Fragment key={`${item.field || "text"}-${index}`}>
                            {renderValue(item)}
                        </React.Fragment>
                    ))}
                </div>
            </div>

            {config.groups.map((group) => {
                const value = r[group.field];
                const empty = vacio(value);

                return (
                    <div className="grupo" key={group.field}>
                        <span>{group.label}</span>

                        <strong>
                            {group.status ? (
                                <span className={`badge-estado ${estadoClass(group)}`}>
                                    {empty ? "—" : arreglar(value)}
                                </span>
                            ) : (
                                empty ? "—" : formatear(value, group.type)
                            )}
                        </strong>
                    </div>
                );
            })}

            <div className="grupo total">
                <span>{config.total.label}</span>

                <strong>
                    {vacio(r[config.total.field])
                        ? "—"
                        : formatear(r[config.total.field], config.total.type)}
                </strong>
            </div>

        </div>
    );
};

export default ConsultReportHeader;
